// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"d371ff05","322":"410f0a6d","461":"410f0a6d","509":"410f0a6d"}[chunkId] + ".chunk.css";
};